// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dgjz","footer":"styles_footer__mortX"};